/**
 * 题目类型元结构系统
 * 导出所有类型、工具和定义
 */

// 核心类型
export * from './types';

// 注册表
export * from './registry';

// 验证器
export * from './validators';

// Schema 生成器
export * from './schemas';

// Stimulus helpers
export * from './stimulus';

// 套卷编排字段（与 prompt / preview 校验同源）
export * from './paperOrchestration';

// 考试专属等级字段 ↔ Question.level
export * from './examLevelFields';

// 一文多题共享材料
export * from './passageSet';

// 类型定义
export { singleChoiceTypeMetadata } from './definitions/singleChoice';
export { multipleChoiceTypeMetadata } from './definitions/multipleChoice';
export { trueFalseTypeMetadata } from './definitions/trueFalse';
export { fillBlankTypeMetadata } from './definitions/fillBlank';

// 自动注册所有类型
import { registerQuestionType } from './registry';
import { singleChoiceTypeMetadata } from './definitions/singleChoice';
import { multipleChoiceTypeMetadata } from './definitions/multipleChoice';
import { trueFalseTypeMetadata } from './definitions/trueFalse';
import { fillBlankTypeMetadata } from './definitions/fillBlank';

// 注册所有内置作答形态
registerQuestionType(singleChoiceTypeMetadata);
registerQuestionType(multipleChoiceTypeMetadata);
registerQuestionType(trueFalseTypeMetadata);
registerQuestionType(fillBlankTypeMetadata);
